import type { JSX } from "react";
export function CompletedCallControls(): JSX.Element {
    return <>Call Completed</>;
}
